import { useLocalSearchParams } from 'expo-router'

import { CommunitiesScreen } from '@/src/features/community/ui/screens/CommunitiesScreen'

export default function () {
  const searchParams = useLocalSearchParams()
  return <CommunitiesScreen searchParams={searchParams} />
}
